import { API_URL } from "../../../helpers/flavor/app";
import { headersJson, headersJsonToken } from "../requestHeaders";

export async function getPrivacy(payload) {
  return await fetch(`${API_URL}/privacy-and-term/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => data.body?.data[0] || {});
}

export async function editPrivacy(payload) {
  return await fetch(`${API_URL}/privacy-and-term/update`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => data);
}

export async function listPrivacyPolicyPublic(payload) {
  return await fetch(`${API_URL}/privacy-and-term/list`, {
    method: "POST",
    headers: headersJson(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => data.body?.data[0] || {});
}
